<template>
  <account-modal class="edit-account-number-modal">
    <template slot="heading">Edit IBAN currency <br> {{ accountNumber.accountNumber }} ({{ channel | channel }})?</template>

    <template slot="content">
      <error-alert :error="error" />

      <v-autocomplete
        id="currency"
        v-model="form.currencies"
        :items="currencyOptions"
        item-text="name"
        item-value="value"
        placeholder="Currency"
        deletable-chips
        small-chips
        multiple
        :error-messages="getValidationErrorMessage('currency')"
      />
    </template>

    <template slot="actions">
      <v-btn
        class="t-edit-button"
        color="light-blue darken-3"
        flat
        :disabled="loading"
        @click="onSubmitButtonClick"
      >submit</v-btn>

      <v-btn
        class="t-edit-cancel-button"
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_ACCOUNT_UPDATE } from '@/events/accounts'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import AccountApi from '@/services/Api/AccountApi'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'
  import currencies from 'assets/data/currencies.json'
  import form from '@/mixins/form'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'EditAccountNumberCurrenciesModal',
    components: {
      AccountModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        accountNumberCurrenciesUpdateApiRequest: new ApiRequest(AccountApi.updateAccountNumberCurrencies),
        form: {
          currencies: null
        }
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      accountId () {
        return this.modal.data.accountId
      },
      accountNumber () {
        return this.modal.data.accountNumber
      },
      channel () {
        return this.modal.data.channel
      },
      loading () {
        return this.accountNumberCurrenciesUpdateApiRequest.loading
      },
      error () {
        return this.accountNumberCurrenciesUpdateApiRequest.error
      },
      currencyOptions () {
        return currencies.map(currency => ({
          name: currency,
          value: currency
        }))
      }
    },
    mounted () {
      this.setFieldValue('currencies', this.accountNumber.currencies)
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onSubmitButtonClick () {
        this.updateAccountNumberCurrency()
          .then(() => {
            this.$eventHub.$emit(EVENT_ACCOUNT_UPDATE, this.profileId)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'IBAN currency has been successfully updated.' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      updateAccountNumberCurrency () {
        return this.accountNumberCurrenciesUpdateApiRequest.execute(this.accountId, this.accountNumber.accountNumber, this.form.currencies)
      }
    }
  }
</script>
